import { render, staticRenderFns } from "./PvcPostcard.vue?vue&type=template&id=20d46854&scoped=true&"
import script from "./PvcPostcard.vue?vue&type=script&lang=js&"
export * from "./PvcPostcard.vue?vue&type=script&lang=js&"
import style0 from "./PvcPostcard.vue?vue&type=style&index=0&id=20d46854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d46854",
  null
  
)

component.options.__file = "PvcPostcard.vue"
export default component.exports